export const FIELD = {
  KIND: 'kind',
}

export const WITHDRAWAL_KIND = {
  CRYPTO: 'crypto',
  BANK: 'bank',
}
